import qs from 'query-string'
import { parseString } from 'xml2js'
import client from '@/store/client'
import router from '@/router'

const getDefaultState = () => {
  return {
    username: '',
    password: '',
    authToken: '',
    environment: '',
    failedLogin: false
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    USER_LOGOUT: async function ({ commit }) {
      commit('reset')
      router.push({ path: '/'})
    },
    USER_LOGIN: async function ({ commit }) {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Logging in',
          subdetail: '',
        })
        const loginRes = await client.post('/v1/Security.asmx/Login', qs.stringify(this.getters['user/user']))
        parseString( loginRes.data , (err, results) => {
          const token = results.content.data[0].$.Token
          commit('setToken', token )
          commit('setEnvironment', results.content.data[0].$.Environment )
          this.dispatch('loader/CHANGE', {
            status: 'COMPLETE',
            detail: 'Activated!',
            subdetail: '',
          })
          router.push({ path: 'home'})
        })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Login Failed',
          subdetail: err.response.data,
        })
        commit('setFailedLogin', true)
      }
    },
  },
  getters: {
    loggedIn: state => state.authToken != '',
    user: state => {
      return {
        username: state.username,
        password: state.password
      }
    }
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    setToken: function(state, data) {
      state.authToken = data || ''
    },
    setFailedLogin: function(state, data) {
      state.failedLogin = data
    },
    setEnvironment: function(state, data) {
      state.environment = data
    }
  },
}
